import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UserComponent } from 'app/layout/common/user/user.component';
import { HasAnyAppRoleComponentDirective } from 'app/modules/auth/app-role.directive';
import { SharedModule } from 'app/shared/shared.module';
import { StoreModule} from "@ngrx/store";
import {EffectsModule} from "@ngrx/effects";
import {UserEffects} from "../../../ngrx/effects/user.effects";
import {userReducer} from "../../../ngrx/reducers/user.reducer";
import {companyReducers} from "../../../ngrx/reducers/company.reducers";

@NgModule({
    declarations: [
        UserComponent,
        HasAnyAppRoleComponentDirective
    ],
    imports     : [
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        SharedModule,
        MatTooltipModule,
        StoreModule.forFeature('user', userReducer), // Set up the feature state for user
        StoreModule.forFeature('company', companyReducers), // Set up the feature state for company
        EffectsModule.forFeature([UserEffects])
    ],
    exports     : [
        UserComponent
    ]
})
export class UserModule
{
}
